export enum DataSourceActionNameEnum {
  SYNC = 'SYNC',
}
